import classNames from 'classnames';
import { Fragment } from 'react';

import ErrorBoundary from '../components/ErrorBoundary';
import { InnerContentScrollbars } from '../components/layout/InnerContentScrollbars';
import {
  HorizontalTrackTypes,
  Scrollbars,
} from '../components/layout/Scrollbars';
import LoggedFooter from '../widgets/LoggedFooter';
import { useModalPageStyles } from './ModalPage.styles';

export default function ModalPage({
  id,
  className,
  innerContentClassName,
  header,
  children,
  wrapInScrollbar,
}) {
  const { styles } = useModalPageStyles();
  const Wrapper = wrapInScrollbar ? InnerContentScrollbars : Fragment;
  return (
    <Scrollbars
      id={id}
      className={classNames(styles.root, className)}
      horizontal={HorizontalTrackTypes.BOTTOM}
    >
      <div className={styles.content}>
        {header}
        <div className={classNames(styles.innerContent, innerContentClassName)}>
          <Wrapper>
            <ErrorBoundary messageId="error.render.page">
              {children}
            </ErrorBoundary>
          </Wrapper>
        </div>
        <LoggedFooter />
      </div>
    </Scrollbars>
  );
}
